const styles = {
    card: {
        borderRadius: '16px',
        minHeight: '98px',
        boxShadow: 'none',
        cursor: 'pointer',
    },
    cardContent: {
        padding: '25px',
    },
    title: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '18px',
        lineHeight: '27px',
        color: '#3876AA',
    },
    subTitle: {
        fontFamily: 'Silka_Medium',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '18px',
        color: '#3876AA',
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    icon: {
        height: '32px',
        width: '32px',
    },
};

export default styles;
